import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'


Vue.use(Vuex)
const vuexLocal = new VuexPersistence({ //将vuex放入local中进行持久化
  storage: window.localStorage
})
const store = new Vuex.Store({
  state: {
    timesData: {
      isTims: false,
      timesNmuber: 30,
    },
    routeType: "",
    typeList: {
      l1Type: false,
      l2Type: false,
      r1Type: false,
      r2Type: false,
      c2Type: false
    },
    userData: null,
    rigthClick: {
      visible: false,
      top: 0,
      left: 0,
      closeOther: false,
      closeCurrent: false,
      closeWhole: false,
    },
    doctorList: {},
    allOrder: {},
    rentGoods: {},
    commodityGroup: {},
    deviceAutho: {},
    remoteMonitor: {},
    configuration: {},
    skuContent: {},
    isCollapse: false,
    financeList: {},
    taskTitle: null,
    taskTileCommon: null,
    tsakName: null,
    taskTileName: null,
    items: [],
    router: 'operateHome',
  },
  mutations: {
    router: (state, payload) => {
      state.router = payload;
    },
    items: (state, payload) => {
      state.items = payload;
    },
    taskTileName: (state, payload) => {
      state.taskTileName = payload;
    },
    tsakName: (state, payload) => {
      state.tsakName = payload;
    },
    taskTileCommon: (state, payload) => {
      state.taskTileCommon = payload;
    },
    taskTitle: (state, payload) => {
      state.taskTitle = payload;
    },
    rentGoods: (state, payload) => {
      state.rentGoods = payload;
    },
    routeType: (state, payload) => {
      state.routeType = payload;
    },
    timesData: (state, payload) => {
      state.timesData = payload;
    },
    typeList: (state, payload) => {
      state.typeList = payload;
    },
    userData: (state, payload) => {
      state.userData = payload;
    },
    isCollapse: (state, payload) => {
      state.isCollapse = payload;
    },
    rigthClick: (state, payload) => {
      state.rigthClick = payload;
    },
    financeList: (state, payload) => {
      state.financeList = payload;
    },
    doctorList: (state, payload) => {
      state.doctorList = payload;
    },
    skuContent: (state, payload) => {
      state.skuContent = payload;
    },
    configuration: (state, payload) => {
      state.configuration = payload;
    },
    remoteMonitor: (state, payload) => {
      state.remoteMonitor = payload;
    },
    USER_INFO: (state, payload) => {
      state.userInfo = payload;
    },
    USER_DATA: (state, payload) => {
      state.allOrder = payload;
    },
    HOME_DATA: (state, payload) => {
      state.commodityGroup = payload;
    },
    MY_INFO: (state, payload) => {
      state.deviceAutho = payload;
    },
  },

  actions: {
    router({
      commit
    }, user) {
      commit('router', user)
    },
    items({
      commit
    }, user) {
      commit('items', user)
    },
    taskTileName({
      commit
    }, user) {
      commit('taskTileName', user)
    },
    tsakName({
      commit
    }, user) {
      commit('tsakName', user)
    },
    taskTileCommon({
      commit
    }, user) {
      commit('taskTileCommon', user)
    },
    taskTitle({
      commit
    }, user) {
      commit('taskTitle', user)
    },
    routeType({
      commit
    }, user) {
      commit('routeType', user)
    },
    timesData({
      commit
    }, user) {
      commit('timesData', user)
    },
    typeList({
      commit
    }, user) {
      commit('typeList', user)
    },

    userData({
      commit
    }, user) {
      commit('userData', user)
    },

    isCollapse({
      commit
    }, user) {
      commit('isCollapse', user)
    },
    rigthClick({
      commit
    }, user) {
      commit('rigthClick', user)
    },

    financeList({
      commit
    }, user) {
      commit('financeList', user)
    },

    doctorList({
      commit
    }, user) {
      commit('doctorList', user)
    },

    skuContent({
      commit
    }, user) {
      commit('skuContent', user)
    },
    allOrder({
      commit
    }, user) {
      commit('USER_DATA', user)
    },

    remoteMonitor({
      commit
    }, user) {
      commit('remoteMonitor', user)
    },

    configuration({
      commit
    }, user) {
      commit('configuration', user)
    },
    rentGoods({
      commit
    }, data) {
      commit('rentGoods', data)
    },

    commodityGroup({
      commit
    }, home) {
      commit('HOME_DATA', home)
    },

    deviceAutho({
      commit
    }, user) {
      commit('MY_INFO', user)
    },
  },
  plugins: [vuexLocal.plugin]
})
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js